import { useState, useEffect, useRef, useCallback } from 'react';

//creates a function that forces a rerender when called (to be used sparingly!)
export const useForceUpdate = () => {
  const [value, setValue] = useState<number>(0);
  return () => setValue((value) => value + 1);
};

// determines whether the component is still mounted, e.g. to make sure component still exists when handling the response of an async request
export const useIsMounted = () => {
  const mountedRef = useRef(false);
  const isMounted = useCallback(() => mountedRef.current, []);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  });

  return isMounted;
};

// returns the previous content of a variable
export const usePrevious = (value: any) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

let uniqueId = 0;
const getUniqueId = () => uniqueId++;

// returns a unique ID for a component
export function useComponentId() {
  const idRef = useRef(getUniqueId());
  return idRef.current;
}
